var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"vue-form__answer-button",class:{ selected: _vm.isSelected },on:{"click":_vm.select}},[(_vm.keyboard)?_c('span',{staticClass:"vue-form__answer-button__key-hint"},[_vm._v("["+_vm._s(_vm.keyboard)+"]")]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }